import g from '#core/global';
import load from '#core/load';

const container_$ = '.evergreen-search';
const checkbox_$ = '.toggle-input-option__input';
const filter_id_attr = 'data-filter-id';
const filter_component_$ = '.filter';
const form_$ = '.form';
const search_input_$ = 'input[type="search"]';

let has_search = false;

const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('evergreen-search')) return false;
		
		load.content(() => {
			has_search = assign_elements();
			if (!has_search) return false;
		});
		load.all(() => {
			has_search = assign_elements();
			if (!has_search) return false;
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_search) return true;
	
	const $containers = document.querySelectorAll(container_$);
	if (!$containers.length) return false;
	
	console.log('Evergreen Search initialized', $containers.length, 'containers found');
	
	// Listen for checkbox changes in evergreen-search
	document.addEventListener(g.change_e, e => {
		const $checkbox = e.target.closest(`${container_$} ${checkbox_$}`);
		if (!$checkbox) return;
		
		console.log('Checkbox clicked in evergreen-search', $checkbox);
		handle_checkbox_change($checkbox);
	});
	
	// Listen for form submit in evergreen-search
	document.addEventListener(g.submit_e, e => {
		const $form = e.target.closest(`${container_$} ${form_$}`);
		if (!$form) return;
		
		e.preventDefault();
		console.log('Form submitted in evergreen-search');
		handle_form_submit($form);
	});
	
	return true;
}


/**
 * Handle checkbox change
 * @param {element} $checkbox
 */
function handle_checkbox_change($checkbox) {
	const checkbox_name = $checkbox.name;
	const checkbox_value = $checkbox.value;
	
	console.log('Checkbox name:', checkbox_name, 'value:', checkbox_value);
	
	if (!checkbox_name || !checkbox_value) {
		console.warn('No name or value found on checkbox');
		return false;
	}
	
	// Get the form to check action
	const $form = $checkbox.closest(form_$);
	if (!$form) {
		console.warn('Form not found');
		return false;
	}
	
	const form_action = $form.getAttribute('action');
	console.log('Form action:', form_action);
	
	// If action is '#', handle on same page
	if (is_same_page(form_action)) {
		handle_same_page_checkbox($checkbox, checkbox_name, checkbox_value);
	} else {
		// Navigate to URL with parameters
		navigate_to_filter_page($form);
	}
}


/**
 * Handle checkbox change on same page
 * @param {element} $checkbox
 * @param {string} checkbox_name
 * @param {string} checkbox_value
 */
function handle_same_page_checkbox($checkbox, checkbox_name, checkbox_value) {
	// Find the filter component
	const $filter_component = document.querySelector(filter_component_$);
	console.log('Filter component:', $filter_component);
	
	if (!$filter_component) {
		console.warn('Filter component not found');
		return false;
	}
	
	// Find the corresponding checkbox in the filter component by name and value
	const $filter_checkbox = $filter_component.querySelector(
		`${checkbox_$}[name="${checkbox_name}"][value="${checkbox_value}"]`
	);
	
	console.log('Target filter checkbox:', $filter_checkbox);
	
	if (!$filter_checkbox) {
		console.warn(`Filter checkbox with name="${checkbox_name}" and value="${checkbox_value}" not found`);
		return false;
	}
	
	// Sync the checked state
	$filter_checkbox.checked = $checkbox.checked;
	console.log('Checkbox synced, triggering change event');
	
	// Trigger change event on the filter checkbox to update results
	const change_event = new Event('change', { bubbles: true });
	$filter_checkbox.dispatchEvent(change_event);
	
	// Scroll to the filter component
	scroll_to_filter($filter_component);
}


/**
 * Handle form submit
 * @param {element} $form
 */
function handle_form_submit($form) {
	const form_action = $form.getAttribute('action');
	console.log('Form action:', form_action);
	
	// If action is '#', handle on same page
	if (is_same_page(form_action)) {
		handle_same_page_submit($form);
	} else {
		// Navigate to URL with parameters
		navigate_to_filter_page($form);
	}
}


/**
 * Handle form submit on same page
 * @param {element} $form
 */
function handle_same_page_submit($form) {
	// Get the search input value
	const $search_input = $form.querySelector(search_input_$);
	if (!$search_input) {
		console.warn('Search input not found');
		return false;
	}
	
	const search_value = $search_input.value.trim();
	console.log('Search value:', search_value);
	
	// Find the filter component
	const $filter_component = document.querySelector(filter_component_$);
	console.log('Filter component:', $filter_component);
	
	if (!$filter_component) {
		console.warn('Filter component not found');
		return false;
	}
	
	// Find the search input in the filter component
	const $filter_search_input = $filter_component.querySelector(search_input_$);
	console.log('Filter search input:', $filter_search_input);
	
	if (!$filter_search_input) {
		console.warn('Filter search input not found');
		return false;
	}
	
	// Set the search value
	$filter_search_input.value = search_value;
	console.log('Search value set, triggering submit');
	
	// Trigger submit on the filter form
	const $filter_form = $filter_search_input.closest('form');
	if ($filter_form) {
		const submit_event = new Event('submit', { bubbles: true, cancelable: true });
		$filter_form.dispatchEvent(submit_event);
	}
	
	// Scroll to the filter component
	scroll_to_filter($filter_component);
}


/**
 * Check if action is same page
 * @param {string} action
 * @return {boolean}
 */
function is_same_page(action) {
	return !action || action === '#' || action === '';
}


/**
 * Navigate to filter page with parameters
 * @param {element} $form
 */
function navigate_to_filter_page($form) {
	const form_action = $form.getAttribute('action');
	
	// Gather form data
	const form_data = new FormData($form);
	const params = new URLSearchParams();
	
	for (const [key, value] of form_data.entries()) {
		if (value) {
			params.append(key, value);
		}
	}
	
	// Build URL with query string and anchor
	const param_string = params.toString();
	const separator = form_action.includes('?') ? '&' : '?';
	const url = param_string 
		? `${form_action}${separator}${param_string}#filter`
		: `${form_action}#filter`;
	
	console.log('Navigating to:', url);
	window.location.href = url;
}


/**
 * 
	// Set the search value
	$filter_search_input.value = search_value;
	console.log('Search value set, triggering submit');
	
	// Trigger submit on the filter form
	const $filter_form = $filter_search_input.closest('form');
	if ($filter_form) {
		const submit_event = new Event('submit', { bubbles: true, cancelable: true });
		$filter_form.dispatchEvent(submit_event);
	}
	
	// Scroll to the filter component
	scroll_to_filter($filter_component);
}


/**
 * Scroll to filter component
 * @param {element} $filter_component
 */
function scroll_to_filter($filter_component) {
	const rect = $filter_component.getBoundingClientRect();
	const scroll_top = window.pageYOffset || document.documentElement.scrollTop;
	const target_position = rect.top + scroll_top - 150; // 150px offset for fixed header
	
	window.scrollTo({
		top: Math.max(0, target_position),
		left: 0,
		behavior: 'smooth',
	});
}
